import { supabase } from '../supabaseClient';

/* Accès aux données du solde de congés payés (profiles.solde_cp et leave_balance_movements).
   Chaque fonction renvoie la requête Supabase telle quelle : aucune logique métier ici. */

// La RLS ne renvoie que son propre journal à un collaborateur, tout le journal aux managers et
// valideurs de congés.
export function fetchLeaveMovements() {
  return supabase
    .from('leave_balance_movements')
    .select('id,user_id,kind,days,balance_after,label,created_at')
    .order('created_at', { ascending: false })
    .order('id', { ascending: false });
}

export function fetchLeaveBalances() {
  return supabase.from('profiles').select('id,dev_id,solde_cp');
}
